import axios from "@/utils/axios";

const API_URL = process.env.VUE_APP_API_URL || "";

export const getStockData = async () => {
  const response = await axios.get(`${API_URL}/stocks`);



  return response.data;
};

export const createStock = async (data) => {
  localStorage.removeItem("stocks");
  const response = await axios.post(`${API_URL}/stocks`, data);

  await getStockData();

  return response.data;
};

export const deleteStock = async (id) => {
  const response = await axios.delete(`${API_URL}/stocks/${id}`);

  return response.data;
};

export const updateStock = async (id, data) => {
  localStorage.removeItem("stocks");
  const response = await axios.put(`${API_URL}/stocks/${id}`, data);

  return response.data;
};
